/**
 * Move a line up (-1) or down (+1) in the list and reassign lineNumber from display order.
 * Existing Firestore lines (docId) are marked modified so lineNumber persists on save.
 */
export function moveLineInArray(lines, fromIndex, delta) {
  if (!Array.isArray(lines) || delta === 0) return lines;

  const toIndex = fromIndex + delta;
  if (fromIndex < 0 || fromIndex >= lines.length) return lines;
  if (toIndex < 0 || toIndex >= lines.length) return lines;

  const next = [...lines];
  const [item] = next.splice(fromIndex, 1);
  next.splice(toIndex, 0, item);

  return next.map((line, i) => ({
    ...line,
    lineNumber: i + 1,
    ...(line.docId ? { modified: true } : {})
  }));
}
